import * as React from "react";
import { getID } from "../../../utils/IdGenerator";
import classNames from "classnames";

type Props = {
	label?: string;
	required?: boolean;
	classes?: string;
	value?: string | number;
	onChange: (value: string) => void;
	type?: string;
	placeholder?: string;
	readOnly?: boolean;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	className?: string;
};

type State = {
	id: string;
};

class TextInput extends React.Component<Props, State> {
	private readonly input: React.RefObject<HTMLInputElement>;
	constructor(props: Props) {
		super(props);
		this.input = React.createRef();
		this.state = {
			id: getID()
		};
	}

	public focus = () => this.input.current!.focus();

	public render() {
		const { className } = this.props;
		
		return (
			<div
				className={
					classNames("form-item form-group form-item form-type-textfield form-group", className)
				}
			>
				<input
					ref={this.input}
					required={this.props.required}
					className={`form-control ${this.props.required ? "required" : ""}`}
					type={this.props.type || "text"}
					id={this.state.id}
					value={this.props.value}
					onChange={this.onChange}
					placeholder={this.props.placeholder}
					readOnly={this.props.readOnly}
					onBlur={this.props.onBlur}
				/>
				{this.props.label && (
					<label className={"control-label " + this.props.classes} htmlFor={this.state.id}>
						{this.props.label}
						{this.props.required === true && (
							<span className="form-required" title="This field is required" aria-hidden>
								*
							</span>
						)}
					</label>
				)}
			</div>
		);
	}

	private readonly onChange = (event: React.ChangeEvent<HTMLInputElement>) =>
		this.props.onChange(event.target.value);
}

export default TextInput;
